import React from 'react';
import {MapContainer, TileLayer, ZoomControl, Popup, FeatureGroup, Marker, CircleMarker} from 'react-leaflet';
import {EditControl} from 'react-leaflet-draw';
import MapController from './controller';
import {Props} from './types';
import {iconRed, iconYellow} from './icons';

const View: React.FC<Props> = (props: Props) => {
  const fgRef = React.useRef<any>();

  const onCreateRect = (event: any) => {
    const drawnItems = fgRef.current._layers;
    if (Object.keys(drawnItems).length > 1) {
      Object.keys(drawnItems).forEach((layerid, index) => {
        if (index > 0) return;
        const layer = drawnItems[layerid];
        fgRef.current.removeLayer(layer);
      });
    }
    props.handlers.createRect(event);
  };

  return (
    <div
      className='d-flex flex-fill'
      style={{height: props.state.height, flex: 2}}
    >
      {props.state.initZoom !== undefined && (
        <MapContainer
          center={[0, 0]}
          // zoom={props.state.initZoom}
          zoom={1}
          className='d-flex flex-fill'
          zoomControl={false}
        >
          {/* Zoom Control */}
          <ZoomControl position='bottomleft'/>

          {/* Drawing */}
          {props.store.searchType === 'rect' && (
            <FeatureGroup ref={fgRef}>
              <EditControl
                position="topright"
                onCreated={onCreateRect}
                draw={{
                  rectangle: true,
                  circle: false,
                  circlemarker: false,
                  marker: false,
                  polyline: false,
                  polygon: false,
                }}
              />
            </FeatureGroup>
          )}

          <MapController {...props}/>

          {/* TileLayer */}
          <TileLayer
            attribution={[
              '&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">Open Street Map</a>',
              ' contributors',
            ].join('')}
            url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'
          />

          {/* Pointer */}
          {props.store.pointerFeature && (
            <Marker
              icon={iconRed}
              position={[
                props.store.pointerFeature.geometry.coordinates[1],
                props.store.pointerFeature.geometry.coordinates[0],
              ]}
            >
              <Popup>
                {props.store.pointerFeature.geometry.coordinates[0]},
                {props.store.pointerFeature.geometry.coordinates[1]}
              </Popup>
            </Marker>
          )}

          {/* Search Results */}
          {props.store.gjfs.all.filter((each) => each.properties.article !== props.store.activeArticleKey)
              .map((each, key) => {
                const [lat, lng] = [each.geometry.coordinates[1], each.geometry.coordinates[0]];
                return (isNaN(lat) || isNaN(lng)) ? null : (
                <CircleMarker radius={4} center={[lat, lng]} key={key} color='#a855f7'>
                  <Popup>{each.properties.label}</Popup>
                </CircleMarker>);
              })}
          {/* Article */}
          {props.store.gjfs.all.filter((each) => each.properties.article === props.store.activeArticleKey)
              .map((each, key) => {
                const [lat, lng] = [each.geometry.coordinates[1], each.geometry.coordinates[0]];
                return (isNaN(lat) || isNaN(lng)) ? null : (
                   <CircleMarker radius={4} center={[lat, lng]} key={key} color='#db2777'>
                     <Popup>{each.properties.label}</Popup>
                   </CircleMarker>
                );
              })}
          {/* Location */}
          {props.store.gjfs.all.filter((each) => each.properties.label === props.store.activeLocation)
              .map((each, key) => {
                const [lat, lng] = [each.geometry.coordinates[1], each.geometry.coordinates[0]];
                return (isNaN(lat) || isNaN(lng)) ? null : (
                    <Marker icon={iconYellow} position={[lat, lng]} key={key}>
                      <Popup>{each.properties.label}</Popup>
                    </Marker>
                  );
              })}

        </MapContainer>
      )}
    </div>
  );
};


export default View;
